import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-ui/core";
import theme from "./theme";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./admin/contexts/AuthContext";
import "./index.css";

ReactDOM.render(
	<React.StrictMode>
		<SnackbarProvider maxSnack={5}>
			<ThemeProvider theme={theme}>
				<AuthProvider>
					<App />
				</AuthProvider>
			</ThemeProvider>
		</SnackbarProvider>
	</React.StrictMode>,
	document.querySelector("#root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
